"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_USER = exports.ADMIN_USERS = void 0;
const __1 = require("..");
exports.ADMIN_USERS = __1.ADMIN.child("/adminUsers");
exports.ADMIN_USER = exports.ADMIN_USERS.sub("/:adminUserId");
